import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import { ReactNode } from "react";

const TableTabs = ({
  tabs,
  panels,
  mb = "1em",
}: {
  tabs: string[];
  panels: ReactNode[];
  mb?: string;
}) => {
  return (
    <Tabs isFitted variant="unstyled">
      <TabList mb={mb}>
        {tabs.map((tab) => (
          <Tab
            key={tab}
            fontWeight="500"
            fontSize="14px"
            borderBottomWidth="3px"
            borderBottomColor="#E6D7F9"
            _selected={{
              bg: "#FBFAFC",
              borderBottomColor: "primary",
            }}
          >
            {tab}
          </Tab>
        ))}
      </TabList>
      <TabPanels>
        {panels.map((panel, index) => (
          <TabPanel key={`${panel}-${index}`} p="0px">
            {panel}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default TableTabs;
